import type { MessageCatalog } from "./en.js";

export const zhCNMessages = {
  "common.none": "无",
  "common.missing": "缺失",
  "common.ready": "就绪",
  "common.unknown": "未知",
  "common.untitled": "（未命名）",
  "common.yes": "是",
  "common.no": "否",
  "command.exit.description": "退出当前会话",
  "command.help.description": "查看可用命令",
  "command.status.description": "查看当前项目状态",
  "command.export.description": "将当前对话导出为 Markdown",
  "command.help.header": "可用命令：",
  "command.help.footer": "其他输入会直接交给 Kitty。",
  "tui.idle": "空闲",
  "tui.running": "正在运行",
  "tui.thinkingElapsed": "思考中 {elapsed}",
  "tui.background": "后台",
  "tui.failed": "失败",
  "tui.waiting": "正在等待",
  "tui.backgroundRunning": "后台正在运行",
  "tui.model": "模型",
  "tui.context": "上下文",
  "tui.commands": "命令",
  "tui.commandPalette": "面板",
  "tui.inputPlaceholder": "输入消息",
  "tui.commandQuery": "命令",
  "tui.commandQueryPlaceholder": "输入名称或说明",
  "tui.commandNoMatches": "没有匹配的命令",
  "tui.history": "历史",
  "tui.historyPlaceholder": "输入关键词",
  "tui.historyNoMatches": "没有匹配的输入",
  "tui.scrollHelp": "↑↓ 滚动  ·  Esc 关闭",
  "tui.newContent": "有新内容 · 按 End 回到底部",
  "tui.newContentRows": "有 {count} 行新内容 · 按 End 回到底部",
  "tui.copySuccess": "已复制所选内容。",
  "tui.copyUnavailable": "复制失败：当前终端没有可用的剪贴板通道。",
  "tui.copyFailed": "复制失败：{error}",
  "tui.draftBusy": "草稿暂时无法提交：SQLite 正在忙，请重试。",
  "tui.externalEditorFailed": "外部编辑器失败：{error}",
  "tui.authorTip": "尽情地探索并享受吧！",
  "tui.tool.created": "已创建",
  "tui.tool.updated": "已更新",
  "tui.tool.read": "已读取",
  "tui.tool.ran": "已运行",
  "tui.tool.updatedPlan": "已更新计划",
  "tui.newSession": "新建会话",
  "tui.sessionControls": "↑↓ 选择  ·  Enter 打开  ·  Esc 退出",
  "tui.unnamedSession": "未命名会话 {id}",
  "tui.time.now": "刚刚",
  "tui.time.minutes": "{count} 分钟前",
  "tui.time.hours": "{count} 小时前",
  "tui.time.days": "{count} 天前",
  "tui.time.weeks": "{count} 周前",
  "tui.time.months": "{count} 个月前",
  "tui.time.years": "{count} 年前",
  "tui.help.discovery": "发现",
  "tui.help.input": "输入",
  "tui.help.navigation": "导航",
  "tui.help.commandCompletion": "命令补全",
  "tui.help.commandPalette": "命令面板",
  "tui.help.historySearch": "搜索输入历史",
  "tui.help.shortcuts": "快捷键帮助",
  "tui.help.submit": "提交",
  "tui.help.newline": "换行",
  "tui.help.lineBounds": "行首/行尾",
  "tui.help.killYank": "剪切行尾/行首/前词并粘贴",
  "tui.help.externalEditor": "外部编辑器",
  "tui.help.historyNavigation": "多行移动或输入历史",
  "tui.help.wordMovement": "按词移动",
  "tui.help.menuConfirm": "补全/确认菜单",
  "tui.help.closeOverlay": "关闭顶层面板",
  "tui.help.interrupt": "中断当前执行",
  "tui.help.redraw": "重绘终端",
  "interaction.steerAccepted": "已引导当前对话。",
  "interaction.interrupted": "已中断当前轮次。你可以继续输入。",
  "interaction.interrupting": "中断正在处理中。",
  "interaction.exitHint": "当前会话不会自动退出。输入 quit 或 q 退出。",
  "interaction.sessionSaved": "会话已保存。",
  "interaction.turnInterrupted": "当前轮次已中断，你可以继续对话。",
  "interaction.requestFailed": "请求失败。",
  "interaction.sessionAlive": "请求失败，但会话仍可继续。",
  "interaction.inputRejected": "输入未被接收：{error}",
  "interaction.recoveredTurns": "已恢复 {count} 个中断的轮次状态。可恢复工作将从持久会话和工具事实继续。",
  "interaction.inspectProcessesFailed": "检查运行中的后台进程失败：{error}",
  "interaction.runningProcesses": "检测到运行中的进程。现在退出会终止它们。",
  "interaction.killProcessesPrompt": "终止所有运行中的进程并退出？[y/N] ",
  "interaction.exitCancelled": "已取消退出，后台进程会继续运行。",
  "interaction.stopProcessesPartial": "无法停止全部后台进程，仍在运行：{pids}。已取消退出。",
  "interaction.stoppedProcesses": "已停止 {count} 个后台进程。",
  "interaction.stopProcessesFailed": "停止后台进程失败：{error}",
  "interaction.forcedStopPartial": "无法停止全部运行中进程，仍在运行：{pids}。",
  "interaction.forcedStopped": "已停止 {count} 个运行中进程。",
  "interaction.forcedStopFailed": "停止运行中进程失败：{error}",
  "local.noMessages": "当前会话还没有消息。",
  "local.conversationExported": "当前对话已导出：{path}",
  "scene.headline.blockedOne": "有一个后台任务需要处理。",
  "scene.headline.blockedMany": "有 {count} 个后台任务需要处理。",
  "scene.headline.watchOne": "有一个后台任务正在运行，但还没有输出。",
  "scene.headline.watchMany": "有 {count} 个后台任务正在运行，但还没有输出。",
  "scene.headline.activeOne": "有一个后台任务正在运行。",
  "scene.headline.activeMany": "有 {count} 个后台任务正在运行。",
  "scene.headline.noSession": "尚未开始会话。",
  "scene.headline.ready": "最近会话已就绪。",
  "scene.noFocus": "当前还没有焦点。",
  "scene.next.wait": "等待活动任务，或使用 `kitty status` / `kitty background` 检查。",
  "scene.next.start": "使用 `kitty` 开始会话。",
  "scene.next.continue": "从最近会话继续。",
  "scene.noBlockers": "没有可见阻塞。",
  "scene.contextUnmeasured": "尚未测量上下文",
  "scene.providerUsageUnavailable": "provider 未提供 usage",
  "scene.noModelRequest": "尚无模型请求记录",
  "scene.noToolProjection": "工具输出尚未需要投影",
  "scene.recoveryOne": "有一个后台任务需要恢复处理。",
  "scene.recoveryMany": "有 {count} 个后台任务需要恢复处理。",
  "scene.wakeOne": "已记录一个唤醒信号。",
  "scene.wakeMany": "已记录 {count} 个唤醒信号。",
  "scene.recoveryClear": "恢复状态正常。",
  "scene.noSkills": "当前项目未发现运行时 skill。",
  "scene.skillIssues": "依赖这些 skill 前先处理其问题。",
  "scene.skillsReady": "skills 已就绪，仅在需要时加载完整内容。",
  "scene.noBackground": "没有后台工作在运行。",
  "scene.backgroundRunning": "后台工作正在运行；等待或检查最新输出。",
  "scene.executionState": "执行状态：{status}。",
  "scene.executionTask": "{kind} 任务",
  "scene.taskActive": "任务正在运行。",
  "scene.cost.context": "上下文 {percent}%{compressed}",
  "scene.cost.compressed": "，已压缩",
  "scene.cost.stable": "稳定前缀 {ratio}",
  "scene.cost.totalTokens": "{count} tokens",
  "scene.cost.cacheUnknown": "缓存未知",
  "scene.cost.cached": "缓存命中 {count}",
  "scene.cost.cacheHit": "命中率 {percent}%",
  "scene.tool.recent": "最近 {count} 项",
  "scene.tool.saved": "预计节省 {count} tokens",
  "scene.tool.recoverable": "{count} 项可恢复",
  "scene.tool.degraded": "{count} 项降级",
  "scene.execution.backgroundBlocked": "使用 `kitty background read {id}` 检查输出，或用 `kitty background stop {id}` 停止。",
  "scene.execution.backgroundWatch": "等待首次输出，或使用 `kitty background read {id}` 检查。",
  "scene.execution.backgroundActive": "使用 `kitty background read {id}` 检查；如需立即取得结果，使用 `kitty background wait {id}`。",
  "scene.execution.inspectBeforeContinue": "继续前检查 {kind} {id}。",
  "scene.execution.watch": "关注 {kind} {id} 的输出或截止时间。",
  "scene.kind.background": "后台",
  "status.project": "项目",
  "status.state": "状态目录",
  "status.currentScene": "当前现场",
  "status.configuration": "当前配置",
  "status.thinking": "思考模式",
  "status.reasoningEffort": "推理强度",
  "status.extensions": "已启用扩展",
  "status.recentEvents": "近期事件",
  "status.now": "当前",
  "status.focus": "焦点",
  "status.next": "下一步",
  "status.blocked": "阻塞",
  "status.background": "后台",
  "status.skills": "Skills",
  "status.cost": "成本",
  "status.toolOutput": "工具输出",
  "status.recovery": "恢复",
  "status.runtimeFacts": "运行事实",
  "status.session": "会话",
  "status.sessions": "会话",
  "status.contextBudget": "上下文预算",
  "status.workset": "工作集",
  "status.modelCache": "模型缓存",
  "status.projectOrientation": "项目定位",
  "status.executions": "执行",
  "status.wakeSignals": "唤醒信号",
  "status.taskFacts": "任务事实",
  "status.latestSession": "最近会话",
  "status.projectFacts": "项目事实",
  "status.hotspots": "上下文预算热点",
  "status.sources": "上下文预算来源",
  "status.cacheLayout": "缓存布局",
  "status.modelRequests": "最近模型请求",
  "status.toolOutputs": "最近工具输出",
  "status.recentExecutions": "最近执行",
  "status.skillsAttention": "需要关注的 Skills",
  "status.files": "{count} 个文件",
  "status.readyCount": "{ready}/{total} 就绪",
  "status.activeTotal": "{active} 活动 / {total} 总计",
  "status.messageCount": "{count} 条消息",
  "status.compressed": "已压缩={mode}",
  "status.notCompressed": "已压缩=否",
  "status.usageUnavailable": "usage 不可用",
  "status.usageProviderUnavailable": "provider 未提供 usage",
  "common.ok": "正常",
  "common.present": "已设置",
  "common.unresolved": "未解析",
  "common.custom": "自定义",
  "common.changed": "有变更",
  "common.clean": "干净",
  "common.unavailable": "不可用",
  "common.notReady": "未就绪",
  "common.failed": "失败",
  "common.tracked": "已跟踪",
  "common.interrupted": "已中断",
  "cli.program.description": "Kitty - 可持久执行的智能体。",
  "cli.version.description": "输出当前 Kitty 版本。",
  "cli.option.model": "覆盖已配置的模型",
  "cli.option.cwd": "本次运行的工作目录",
  "cli.option.json": "输出结构化 JSON。",
  "cli.option.timeoutMs": "等待超时毫秒数。",
  "cli.option.readMode": "读取模式：summary、tail 或 full。",
  "cli.option.tail": "tail 模式读取的输出行数。",
  "cli.argument.promptOptional": "可选的一次性任务；省略时进入交互模式。",
  "cli.argument.promptRequired": "要发送的任务",
  "cli.argument.sessionIdOptional": "会话 ID；默认使用最近会话。",
  "cli.argument.backgroundAction": "可选动作：list、read、wait、stop",
  "cli.argument.backgroundId": "read、wait 或 stop 使用的后台执行 ID",
  "cli.argument.changeIdOptional": "可选的变更 ID",
  "cli.command.background": "检查、读取、等待或停止后台执行。",
  "cli.command.start": "初始化当前项目并打开 Kitty 本地控制台。",
  "cli.command.undo": "撤销最近一次或指定 ID 的变更。",
  "cli.command.status": "查看当前项目运行状态。",
  "cli.command.run": "在新会话中运行一次性任务。",
  "cli.command.resume": "以交互模式恢复最近或指定会话。",
  "cli.command.telegram": "提供 Telegram 私聊控制。",
  "cli.command.telegramServe": "通过长轮询运行 Telegram 私聊服务。",
  "cli.command.weixin": "通过微信 iLink 私聊远程控制 Kitty。",
  "cli.command.weixinLogin": "扫码登录微信 iLink。",
  "cli.command.weixinServe": "运行微信 iLink 私聊服务。",
  "cli.command.weixinLogout": "清除微信 iLink 登录状态。",
  "cli.run.incomplete": "本次运行未完成。",
  "cli.background.idRequired": "background {action} 需要执行 ID。",
  "cli.background.unknownAction": "未知 background 动作：{action}。请使用 list、read、wait 或 stop。",
  "cli.background.none": "尚无后台执行记录。",
  "cli.sessions.none": "没有已保存的会话。",
  "cli.start.ready": "Kitty 本地控制台已就绪。",
  "cli.start.browserFailed": "无法自动打开浏览器，请手动打开上方地址。",
  "cli.undo.done": "已撤销 {id}",
  "cli.tui.requiresTty": "kitty 需要交互式 TTY。一次性执行请使用 kitty run <prompt>。",
  "cli.tui.unavailable": "TUI 入口不可用。请运行 npm.cmd run build 后重试。原因：{error}",
  "cli.sessionPicker.prompt": "选择会话（输入编号，0 新建）：",
  "cli.sessionPicker.recent": "最近会话",
  "cli.sessionPicker.new": "新建会话",
  "cli.sessionPicker.invalid": "无效选择，请重新输入。",
  "cli.sessionPicker.invalidRange": "请输入列表编号，或输入 0 新建会话。",
  "cli.intro.session": "会话",
  "cli.intro.cwd": "工作目录",
  "cli.intro.tools": "工具",
  "cli.intro.commands": "命令",
  "preflight.project": "项目",
  "preflight.state": "状态目录",
  "preflight.file": "文件",
  "preflight.envKeys": "环境变量",
  "preflight.activeExpected": "{active} 个有效 / {expected} 个预期",
  "preflight.missingKeys": "缺失配置",
  "preflight.provider": "provider",
  "preflight.model": "模型",
  "preflight.baseUrl": "基础地址",
  "preflight.providerPreset": "provider 预设",
  "preflight.providerProfile": "provider 配置档",
  "preflight.modelProfile": "模型配置档",
  "preflight.wireApi": "通信 API",
  "preflight.catalog": "模型目录",
  "preflight.apiKey": "API 密钥",
  "preflight.status": "预检",
  "preflight.next": "下一步",
  "preflight.runInit": "运行 `kitty start` 创建本地 .kitty 文件并打开控制台",
  "preflight.fillMissing": "打开 `.kitty/.env` 并补全缺失配置",
  "preflight.setApiKey": "在 `.kitty/.env` 中设置 `KITTY_API_KEY`",
  "preflight.startKitty": "使用 `kitty` 启动 Kitty",
  "preflight.reviewEnv": "检查 `.kitty/.env`",
  "status.totalSkipped": "共 {total} 项，跳过 {skipped} 项",
  "status.blockedCount": "{count} 项阻塞",
  "status.label.reason": "原因",
  "status.label.messages": "消息",
  "status.label.directories": "目录",
  "status.label.scripts": "脚本",
  "status.label.tests": "测试",
  "status.label.git": "git",
  "status.label.read": "读取",
  "status.label.changed": "变更",
  "status.label.lastTool": "最后工具",
  "status.label.change": "变更 ID",
  "status.label.chars": "字符",
  "status.label.lines": "行",
  "status.label.stable": "稳定前缀",
  "status.label.stableChars": "稳定字符",
  "status.label.tail": "易变尾部",
  "status.label.tailChars": "尾部字符",
  "status.label.stableRatio": "稳定比例",
  "status.label.stableSources": "稳定来源",
  "status.label.volatileSources": "易变来源",
  "status.label.provider": "provider",
  "status.label.duration": "耗时",
  "status.label.usage": "用量",
  "status.label.kind": "类型",
  "status.label.mode": "模式",
  "status.label.raw": "原始 tokens",
  "status.label.projected": "投影 tokens",
  "status.label.saved": "节省 tokens",
  "status.label.savedRatio": "节省比例",
  "status.label.recoverable": "可恢复",
  "status.label.degraded": "已降级",
  "status.label.fullOutput": "完整输出",
  "status.label.risk": "风险",
  "status.label.summary": "摘要",
  "status.label.next": "下一步",
  "status.label.lastOutput": "最后输出",
  "status.label.actor": "执行者",
  "status.label.expected": "预期输出",
  "status.label.resources": "资源",
  "status.label.dependencies": "依赖",
  "status.label.host": "宿主",
  "status.label.message": "消息",
  "status.label.error": "错误",
  "status.label.state": "状态",
  "status.label.issues": "问题",
  "status.label.cached": "缓存命中",
  "status.label.cacheMiss": "缓存未命中",
  "status.label.cacheHit": "命中率",
  "status.label.input": "输入 tokens",
  "status.label.output": "输出 tokens",
  "status.label.reasoning": "推理 tokens",
  "status.label.cacheRead": "缓存读取",
  "status.label.cacheWrite": "缓存写入",
  "runtime.channel.agent": "Kitty",
  "runtime.channel.system": "系统",
  "runtime.reasoning": "思考",
  "runtime.tool": "工具",
  "runtime.result": "结果",
  "runtime.preview": "预览",
  "runtime.content": "内容",
  "runtime.toolFailed": "工具失败：{name}",
  "runtime.thinking": "思考中",
  "telegram.help.help": "/help            查看 Telegram 使用帮助",
  "telegram.help.stop": "/stop            停止当前 Telegram 任务，不关闭机器人服务",
  "telegram.help.status": "/status          查看当前运行状态",
  "telegram.help.files": "文件用法：",
  "telegram.help.sendFile": "- 直接向私聊发送文件。Kitty 会下载文件并附加到当前会话。",
  "telegram.help.analyzeFile": "- 可以让 Kitty 分析刚发送的文件，或发回指定文件。",
  "telegram.help.stopTask": "- 需要停止当前任务时使用 /stop。",
  "telegram.help.note": "终端专用命令不能在 Telegram 中使用。",
  "telegram.blockedLocal": "Telegram 不支持这个命令。使用 /help 查看可用命令。",
  "telegram.prefix.warning": "警告",
  "telegram.prefix.error": "错误",
  "telegram.prefix.interrupt": "中断",
  "telegram.stopConfirmed": "正在停止当前 Telegram 任务。机器人会保持在线，等待你的下一个请求。",
  "telegram.noTask": "当前没有正在运行的 Telegram 任务。",
  "remote.command.stop.description": "停止当前任务，服务保持在线",
  "remote.command.new.description": "开始新会话并保留之前的历史",
  "remote.stopConfirmed": "正在停止当前任务，服务保持在线，可以继续发送新请求。",
  "remote.noTask": "当前没有正在运行的任务。",
  "remote.newConfirmed": "新会话已经就绪，之前的会话仍然保留。",
  "remote.noSession": "当前聊天还没有创建会话。",
  "remote.blockedCommand": "这里不支持这个命令，请使用 /help 查看当前命令。",
  "telegram.tokenMissing": "缺少 Telegram token。请设置 KITTY_TELEGRAM_TOKEN 或 config.telegram.token。",
  "telegram.whitelistEmpty": "Telegram 白名单为空。请设置 KITTY_TELEGRAM_ALLOWED_USER_IDS 或 config.telegram.allowedUserIds。",
  "weixin.notLoggedIn": "微信尚未登录，请先运行 kitty weixin login。",
  "weixin.whitelistEmpty": "微信白名单为空，请设置 KITTY_WEIXIN_ALLOWED_USER_IDS。",
  "weixin.qrCode": "[weixin] 请在微信中打开或扫描：{value}",
  "weixin.scanned": "[weixin] 已扫码，等待确认。",
  "weixin.loginSucceeded": "[weixin] 登录成功 user={userId}",
  "weixin.loggedOut": "[weixin] 已退出登录。",
  "remote.service.online": "私聊远程服务已启动",
  "remote.service.state": "状态目录",
  "remote.service.allowed": "白名单用户数",
  "remote.service.transport": "连接方式",
  "cli.setup.projectNotReady": "项目尚未具备运行条件。",
  "cli.setup.createTemplate": "创建或修复项目模板：kitty start",
  "cli.setup.configFile": "配置文件：{path}",
  "cli.setup.fillAndStart": "然后补全必需配置并启动 Kitty。",
  "cli.setup.originalError": "原始错误：{error}",
  "cli.setup.apiKeyMissing": "缺少 provider API 密钥。",
  "cli.setup.setApiKey": "在此文件设置 KITTY_API_KEY：{path}",
  "cli.setup.thenRestart": "然后重新启动 Kitty。",
  "common.active": "活动",
  "common.undone": "已撤销",
  "status.label.pid": "进程 ID",
  "status.label.health": "健康状态",
  "status.label.deadline": "截止时间",
  "status.label.files": "文件",
  "interaction.queuedRestart": "已接收的输入仍已持久保存，将在重启后继续。",
  "interaction.detachedRecovery": "当前工作已持久保存，再次打开此会话时会继续。",
  "web.pageTitle": "Kitty Agent",
  "web.common.back": "返回工作台",
  "web.common.save": "保存配置",
  "web.common.sendTest": "测试连接",
  "web.common.testingConnection": "正在验证连接、密钥和模型列表，请稍候…",
  "web.common.start": "启动",
  "web.common.stop": "停止",
  "web.common.github": "在 GitHub 打开 Kitty",
  "web.common.officialSite": "官方网站",
  "web.common.apiKeyPortal": "注册 / 获取 API Key",
  "web.common.notConfigured": "未配置",
  "web.common.custom": "自定义配置",
  "web.common.requestFailed": "请求失败（{status}）",
  "web.common.connectionSuccess": "连接成功",
  "web.common.serviceState": "服务状态：{status}",
  "web.common.models": "{count} 个模型",
  "web.common.skills": "{count} 个可用 Skill",
  "web.common.eventUpdated": "事件已更新",
  "web.common.eventDisconnected": "本地事件连接中断，浏览器会自动重连，服务运行事实不受影响。",
  "web.status.stopped": "未启动",
  "web.status.starting": "启动中",
  "web.status.running": "运行中",
  "web.status.stopping": "停止中",
  "web.status.failed": "启动失败",
  "web.status.unknown": "未知状态",
  "web.login.waiting": "等待扫码",
  "web.login.scanned": "已扫码",
  "web.login.connected": "已登录",
  "web.login.failed": "登录失败",
  "web.workflow.basic": "基础设置",
  "web.workflow.config": "语言模型设置",
  "web.workflow.media": "图像与视频设置",
  "web.workflow.plugins": "插件与 Skill 开关",
  "web.workflow.other": "其他设置",
  "web.workflow.weixin": "微信远程控制",
  "web.workflow.telegram": "Telegram 远程控制",
  "web.workflow.skills": "技能",
  "web.workflow.web": "Kitty 网页端控制",
  "web.workflow.loadingConfig": "读取当前配置...",
  "web.workflow.loadingService": "读取服务状态...",
  "web.workflow.loadingSkills": "读取技能...",
  "web.workflow.basicNote": "语言与人格",
  "web.workflow.configNote": "Provider 与模型",
  "web.workflow.mediaNote": "生图与生视频",
  "web.workflow.mediaSummary": "独立的多模态 Provider 与模型配置",
  "web.workflow.pluginsNote": "能力开关",
  "web.workflow.otherNote": "低频参数",
  "web.workflow.otherSummary": "上下文、文件与远程协议参数",
  "web.workflow.weixinNote": "微信远程控制",
  "web.workflow.telegramNote": "Telegram 远程控制",
  "web.workflow.skillsNote": "只读查看",
  "web.workflow.webNote": "用户友好的控制界面",
  "web.workflow.webSummary": "网页对话与运行控制",
  "web.workflow.guide": "选择一个模块，继续设置或管理 Kitty。",
  "web.config.description": "选择语言模型 Provider、密钥和推理行为。",
  "web.config.currentTitle": "当前配置",
  "web.config.providerTitle": "配置 Provider",
  "web.config.providerHint": "选择预设会填入推荐值；所有字段仍可直接修改。",
  "web.config.validationTitle": "测试连接",
  "web.config.validationHint": "使用最后保存的配置读取模型元数据，不生成内容，也不消耗模型 Token。",
  "web.config.settingsTitle": "模型行为",
  "web.config.settingsHint": "思考模式、推理强度、输出上限和思考过程显示只在保存后生效。",
  "web.config.extensionsTitle": "Extensions",
  "web.config.runtimeTitle": "运行参数",
  "web.config.preset": "Provider 预设",
  "web.config.provider": "Provider",
  "web.config.model": "模型",
  "web.config.baseUrl": "Base URL",
  "web.config.apiKey": "API Key",
  "web.config.apiKeyHint": "这里显示当前 Provider 的密钥。切换 Provider 后，请填入它对应的 API Key。",
  "web.config.currentLoaded": "已载入当前值",
  "web.config.saved": "Kitty 配置已保存。",
  "web.config.probeSuccess": "连接成功 · {probe} · {models} · {baseUrl}",
  "web.media.description": "独立配置图片和视频生成 Provider，不影响当前语言模型。",
  "web.media.currentTitle": "当前多模态配置",
  "web.media.providerTitle": "配置图片与视频 Provider",
  "web.media.providerHint": "图片和视频共享媒体密钥，但模型与语言模型完全独立。",
  "web.media.preset": "多模态预设",
  "web.media.provider": "Provider",
  "web.media.imageModel": "图片模型",
  "web.media.videoModel": "视频模型",
  "web.media.baseUrl": "Base URL",
  "web.media.apiKey": "媒体 API Key",
  "web.media.apiKeyHint": "这里显示当前媒体密钥；留空保存会保留原值。",
  "web.media.timeout": "请求超时（毫秒）",
  "web.media.pollInterval": "视频轮询间隔（毫秒）",
  "web.media.saved": "图像与视频配置已保存。",
  "web.media.validationTitle": "测试多模态连接",
  "web.media.validationHint": "只读取模型端点，不会生成图片或视频。",
  "web.media.studioTitle": "直接生成媒体",
  "web.media.studioHint": "通过当前媒体 Provider 直接发起图片或视频请求。",
  "web.media.imageTab": "图片",
  "web.media.videoTab": "视频",
  "web.media.prompt": "提示词",
  "web.media.size": "图片清晰度",
  "web.media.ratio": "图片比例",
  "web.media.videoSize": "视频画幅",
  "web.media.duration": "时长",
  "web.media.negativePrompt": "负面提示词",
  "web.media.generateImage": "生成图片",
  "web.media.generateVideo": "创建视频",
  "web.media.stopPolling": "停止查询",
  "web.media.download": "下载",
  "web.media.videoId": "视频 ID",
  "web.media.nextPoll": "下次查询",
  "web.media.generating": "正在生成图片…",
  "web.media.imageCompleted": "图片已生成",
  "web.media.videoCreating": "正在创建视频任务…",
  "web.media.videoQueued": "视频排队中",
  "web.media.videoWaiting": "等待下一次查询",
  "web.media.videoInProgress": "视频生成中",
  "web.media.videoCompleted": "视频已生成",
  "web.basic.description": "选择界面语言和 Agent 人格。人格来自当前 profile registry。",
  "web.basic.saved": "基础设置已保存。",
  "web.plugins.description": "启用或停用 Kitty 的插件，并查看当前项目的 Skill。",
  "web.plugins.saved": "插件设置已保存。",
  "web.other.description": "调整上下文、文件限制以及微信和 Telegram 的低频协议参数。",
  "web.other.saved": "其他设置已保存。",
  "web.weixin.description": "设置允许使用 Kitty 的用户，扫码登录后启动本地服务。",
  "web.weixin.allowedTitle": "用户白名单",
  "web.weixin.userId": "用户 ID",
  "web.weixin.usersPlaceholder": "多个 ID 用逗号分隔",
  "web.weixin.saved": "允许用户已保存。",
  "web.weixin.loginTitle": "登录微信",
  "web.weixin.loginHint": "二维码和登录凭证只属于当前本地项目。",
  "web.weixin.generateQr": "生成二维码",
  "web.weixin.logout": "退出登录",
  "web.weixin.startTitle": "启动服务",
  "web.weixin.startHint": "启动后，消息和 Agent 执行过程会显示在下方。",
  "web.weixin.streamEmpty": "微信服务事件会显示在这里",
  "web.weixin.waitingLogin": "等待微信扫码登录",
  "web.weixin.credentialsCleared": "微信登录凭证已清除",
  "web.weixin.qrGenerating": "正在生成二维码...",
  "web.weixin.connected": "微信凭证已连接",
  "web.weixin.qrAlt": "微信登录二维码",
  "web.telegram.description": "保存 Bot Token 和允许用户，验证机器人身份后启动服务。",
  "web.telegram.botTitle": "配置 Bot",
  "web.telegram.token": "Bot Token",
  "web.telegram.tokenHint": "这里显示 `.kitty/.env` 的当前值。留空保存会保留原 Token。",
  "web.telegram.users": "允许的用户 ID",
  "web.telegram.usersPlaceholder": "多个 ID 用逗号分隔",
  "web.telegram.saved": "Telegram 配置已保存。",
  "web.telegram.verifyTitle": "验证 Bot Token",
  "web.telegram.verifyHint": "调用 Telegram `getMe`，成功后显示机器人用户名。",
  "web.telegram.startTitle": "启动服务",
  "web.telegram.startHint": "启动后从 Telegram 发消息，完整信息流会显示在下方。",
  "web.telegram.streamEmpty": "Telegram 服务事件会显示在这里",
  "web.telegram.probeSuccess": "连接成功 · @{identity}",
  "web.skills.description": "查看当前项目能够发现的能力包。浏览器不会修改 Skill 文件。",
  "web.skills.empty": "当前项目没有可用 Skill",
  "web.skills.source": "Skill 源文件",
  "web.stream.inbound": "收到消息",
  "web.stream.status": "服务",
  "web.stream.reasoning": "思考",
  "web.stream.assistant": "回复中",
  "web.stream.final": "最终回复",
  "web.stream.toolCall": "调用工具",
  "web.stream.toolProgress": "工具运行",
  "web.stream.toolResult": "工具结果",
  "web.stream.toolError": "工具错误",
  "web.stream.error": "错误",
  "web.shell.connected": "已连接",
  "web.shell.disconnected": "连接已断开",
  "web.shell.thinking": "思考中",
  "web.shell.stopped": "已停止",
  "web.shell.inputPlaceholder": "输入消息",
  "web.shell.send": "发送",
  "web.shell.stop": "停止",
  "web.shell.empty": "把任务交给 Kitty。",
  "web.shell.reasoning": "思考中",
  "web.shell.user": "你",
  "web.shell.assistant": "Kitty",
  "web.shell.toolUpdating": "正在更新 {target}",
  "web.shell.toolWriting": "正在写入文件",
  "web.shell.toolReading": "正在读取 {target}",
  "web.shell.toolReadingGeneric": "正在读取文件",
  "web.shell.toolRunning": "正在运行 {command}",
  "web.shell.toolRunningGeneric": "正在运行命令",
  "web.shell.toolCalling": "正在调用 {name}",
  "web.shell.toolUpdated": "已更新 {target}",
  "web.shell.toolCreated": "已创建 {target}",
  "web.shell.toolRead": "已读取 {target}",
  "web.shell.toolDone": "工具已完成",
  "web.shell.toolFailed": "工具执行失败",
  "web.shell.toolPlan": "计划已更新 · {completed}/{total} 项完成",
  "web.shell.commandDone": "命令已完成",
  "web.shell.commandFailed": "命令执行失败",
  "web.runtime.locale": "界面语言",
  "web.runtime.profile": "Agent 配置档",
  "web.runtime.thinking": "思考模式",
  "web.runtime.reasoningEffort": "推理强度",
  "web.runtime.maxOutputTokens": "最大输出 Token 数",
  "web.runtime.contextWindowMessages": "上下文消息窗口",
  "web.runtime.maxContextChars": "上下文最大字符数",
  "web.runtime.contextSummaryChars": "上下文摘要字符数",
  "web.runtime.maxReadBytes": "单次文件读取上限（字节）",
  "web.runtime.projectDocMaxBytes": "项目文档读取上限（字节）",
  "web.runtime.commandStallTimeoutMs": "命令无输出超时（毫秒）",
  "web.runtime.showReasoning": "显示思考过程",
  "web.runtime.telegramApiBaseUrl": "Telegram API 地址",
  "web.runtime.telegramProxyUrl": "Telegram 代理地址",
  "web.runtime.telegramPollingTimeoutSeconds": "Telegram 轮询超时（秒）",
  "web.runtime.telegramPollingLimit": "Telegram 单次轮询数量",
  "web.runtime.telegramPollingRetryBackoffMs": "Telegram 轮询重试间隔（毫秒）",
  "web.runtime.telegramMessageChunkChars": "Telegram 消息分段字符数",
  "web.runtime.telegramTypingIntervalMs": "Telegram 输入状态间隔（毫秒）",
  "web.runtime.telegramDeliveryMaxRetries": "Telegram 发送重试次数",
  "web.runtime.telegramDeliveryBaseDelayMs": "Telegram 发送基础延迟（毫秒）",
  "web.runtime.telegramDeliveryMaxDelayMs": "Telegram 发送最大延迟（毫秒）",
  "web.runtime.weixinBaseUrl": "微信 iLink 服务地址",
  "web.runtime.weixinCdnBaseUrl": "微信 CDN 地址",
  "web.runtime.weixinPollingTimeoutMs": "微信轮询超时（毫秒）",
  "web.runtime.weixinPollingRetryBackoffMs": "微信轮询重试间隔（毫秒）",
  "web.runtime.weixinMessageChunkBytes": "微信消息分段字节数",
  "web.runtime.weixinTypingIntervalMs": "微信输入状态间隔（毫秒）",
  "web.runtime.weixinQrTimeoutMs": "微信二维码超时（毫秒）",
  "web.runtime.weixinRouteTag": "微信路由标记",
  "web.locale.zh-CN": "简体中文",
  "web.locale.en": "英文",
  "web.locale.ja": "日文",
  "web.locale.ko": "韩文",
  "web.option.enabled": "启用",
  "web.option.disabled": "停用",
  "web.option.xhigh": "极高",
  "web.option.high": "高",
  "web.option.medium": "中",
  "web.option.low": "低",
  "web.option.minimal": "最低",
  "web.option.true": "是",
  "web.option.false": "否",
  "web.extension.todo": "维护会话清单并显示任务进度。",
  "web.extension.scheduler": "不依赖模型轮询的持久提醒与本地命令计划。",
  "web.extension.worktree": "发现并管理 Git worktree 生命周期。",
  "web.extension.network": "执行 HTTP 请求、探测、下载、追踪与 OpenAPI 检查。",
  "web.extension.media": "生成图片，并按 video_id 创建、查询和下载视频。",
  "web.extension.background": "持久记录生命周期和输出的后台命令。",
  "web.extension.documents": "分段读取 DOCX 和文字版 PDF，并写入 Word 文档。",
  "web.extension.skills": "发现并显式加载项目 Skill。",
  "web.event.toolFailed": "{name} 执行失败",
  "web.event.toolProgress": "{name} 正在接收参数",
  "web.event.writeDocument": "写入文档",
  "web.event.changeFile": "修改文件",
  "web.event.readDocument": "读取文档",
  "web.event.readFile": "读取文件",
  "web.event.fromOffset": "从 {offset} 开始",
  "web.event.runCommand": "运行命令",
  "web.event.directory": "目录：{path}",
  "web.event.runTool": "运行工具 · {name}",
  "web.event.fileCreated": "文件已创建",
  "web.event.fileUpdated": "文件已更新",
  "web.event.documentCreated": "文档已创建",
  "web.event.documentUpdated": "文档已更新",
  "web.event.readComplete": "读取完成",
  "web.event.commandFailed": "命令执行失败",
  "web.event.commandComplete": "命令执行完成",
  "web.event.planUpdated": "计划已更新 · {completed}/{total}",
  "web.event.toolComplete": "{name} 执行完成",
  "web.event.missingTarget": "未提供目标",
} satisfies MessageCatalog;
